import { useRef } from "react"
import { Alert, Stack, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { Bound } from "lib/@components/binding/Bound"
import { BoundCheckBox } from "lib/@components/standard-checkbox"
import { If } from "lib/@components/switch"
import { ApprovedSchedulesList } from "./approved-schedules-list"
import { SeedSource } from "authoring/lib/enum/seed-source.mjs"

export function SendToLegacyOptionsDialog({
    approvedSchedules = [],
    actionLabel = "Send to Legacy",
    actionVerb = "sent",
    showIncrementVersion = true,
}) {
    const hasOnlyNewSchedules = approvedSchedules.every((s) => s.seedSource === SeedSource.NEW)
    const canIncrementVersion = showIncrementVersion && !hasOnlyNewSchedules
    const options = useRef({ incrementVersion: showIncrementVersion ? !hasOnlyNewSchedules : true }).current

    return (
        <DialogBox
            title={<Typography variant="h5">{actionLabel}</Typography>}
            value={true}
            okCaption={actionLabel}
            beforeOk={resolveOptions}
            data-cy="send-to-legacy-options-dialog"
        >
            <Bound target={options}>
                <Stack spacing={3}>
                    <Stack spacing={1}>
                        <Alert severity="info" data-cy="send-to-legacy-approved-message">
                            {scheduleCountLabel(approvedSchedules.length)} will be {actionVerb} to Legacy
                        </Alert>
                        <ApprovedSchedulesList schedules={approvedSchedules} data-cy="send-to-legacy-approved-list" />
                    </Stack>
                    <If value={canIncrementVersion}>
                        <BoundCheckBox
                            field="incrementVersion"
                            label="Increment version number"
                            labelRight
                            data-cy="increment-version-checkbox"
                        />
                    </If>
                </Stack>
            </Bound>
        </DialogBox>
    )

    function resolveOptions() {
        return { incrementVersion: options.incrementVersion }
    }
}

function scheduleCountLabel(count) {
    if (count === 1) return "1 approved schedule"
    return `${count} approved schedules`
}
